"use client";

import { useLocale, useTranslations } from "use-intl";

import { yearRangeToParam } from "@/lib/faceted-search-url";
import { buildSearchSeoHeading, isSearchBrowseState } from "@/lib/seo";

import type { SearchFilters } from "./use-search-state";

export function useSearchSeoCopy(filters: SearchFilters) {
  const t = useTranslations("globals.search");
  const tt = useTranslations("globals.search.albumType");
  const tSeo = useTranslations("globals.seo");
  const tf = useTranslations("shared.formats");
  const tg = useTranslations("shared.genres");
  const ts = useTranslations("shared.styles");
  const locale = useLocale();
  const input = {
    q: filters.query,
    genre: filters.genre,
    style: filters.style,
    type: filters.type,
    format: filters.format,
    country: filters.country,
    origin: filters.origin,
    year: yearRangeToParam(filters.yearFrom, filters.yearTo),
    page: filters.page,
    label: filters.label,
  };
  const translators = {
    seo: tSeo,
    search: t,
    albumType: tt,
    formats: tf,
    genres: tg,
    styles: ts,
  };
  const show = !filters.query.trim() && isSearchBrowseState(input);
  if (!show) return { heading: null };
  return {
    heading: buildSearchSeoHeading(input, translators, locale),
  };
}
